import { useRouter } from "next/router";
import Script from "next/script";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/styles.scss";
import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../.sourceflow/metadata.json";

import Layout from "../components/layout";

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  // Exclude `/components` page from being wrapped in Layout and SourceFlowHead
  const isComponentsPage = router.pathname === "/components";

  return isComponentsPage ? (
    <>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </>
  ) : (
    <Layout>
      <SourceFlowHead metaObject={metaObject} addTracker={true} />
      <Component {...pageProps} />
      {router.asPath === "/job-seekers/graduate-opportunities" && (
        <Script
          src="https://bot.leadoo.com/bot/dynamic.js?company=ea160b0a"
          strategy="afterInteractive"
          async
        />
      )}
    </Layout>
  );
}

export default MyApp;
